import React, { useEffect } from "react";
import { Trans, translate } from "react-i18next";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import * as $ from "jquery";

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

function Dialog({ children, title, handleDismiss, type = 'default', handleSuccess, ...props }) {
  useEffect(() => {
    $("#btnSuccessDialog").click();
    $("#modalSuccessDialog").on("hidden.bs.modal", () => {
      handleClick();
    });

    return () => {
      const backdrop = document.querySelector(".modal-backdrop");
      // elimina todos los elementos
      if (backdrop) {
        backdrop.remove();
      }
    }
  }, []);

  const handleClick = () => {
    if (handleDismiss) handleDismiss();
  };

  const handleSubmit = () => {
    if (handleSuccess) handleSuccess();
  }

  const { t } = props;
  return (
    <div>
      <button
        className="hidden"
        data-target="#modalSuccessDialog"
        data-toggle="modal"
        id="btnSuccessDialog"
        type="button"
      ></button>
      <div className="modal fade" id="modalSuccessDialog" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              {title && <h4>{title}</h4>}
              {children}
            </div>
            <div className="modal-footer">
              {type === 'modal' && (
                <button
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  style={{ background: "#FFF", border: "1px solid #3CC", color: "#3CC" }}
                  type="button">
                  Cancelar
                </button>
              )}
              <button
                className="btn btn-primary"
                data-dismiss="modal"
                type="button"
                onClick={handleSubmit}
              >
                {props.success_text ? props.success_text : t("dashboard.room_payment.btn_modal_exit")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default compose(translate("common"), withRouter)(Dialog);



// WEBPACK FOOTER //
// ./src/components/Dialog/index.jsx